<template>
  <div class="section-specialist">
    <div class="section-specialist__left">
      <h1>
        <FuncTextWithSlots :items="dict.title">
          <template #bold="{data}">
            <br>
            <b>{{ data }}</b>
          </template>
        </FuncTextWithSlots>
      </h1>
      <a :href="URI_REGISTER"><UiBtn
        type="search"
        class="cta-btn"
        :default-icon="true"
      >{{ dict.signup }}</UiBtn></a>
      <div class="mobile-map hide-desktop">
        <img
          src="~@/assets/images/decorations/map.svg"
          alt="asset"
          class="map"
        >
        <SpecialistsMap />
      </div>
    </div>
    <div class="section-specialist__right hide-mobile">
      <img
        src="~@/assets/images/decorations/map.svg"
        alt="asset"
        class="map"
      >
      <SpecialistsMap />
    </div>
  </div>
</template>

<script>
import { ExternalLinks } from '@/config';
import { FuncTextWithSlots, UiBtn } from '@/components';
import { SpecialistsMap } from "./_components";
import animations from "./_animations";
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Specialist',
  components: {
    FuncTextWithSlots,
    UiBtn,
    SpecialistsMap,
  },
  data() {
    return {

      stats: {
        docs: 0,
        specs: 0,
        cities: 0,
      },

    };
  },
  computed: {
    URI_REGISTER: () => ExternalLinks.MYDR_REGISTER,
    dict() {
      return this.$i.tr().specialists;
    },
  },
  mounted() {
    animations.animNums(this.stats, this.$refs.stats);
  },
});
</script>

<style lang="scss" src="./styles.scss" />
